const snakeToTitle = (inputStr) => {
  return inputStr
    .split('_')
    .map((word) => word.slice(0, 1).toUpperCase() + word.slice(1))
    .join(' ');
};

export default snakeToTitle;
